import React, { ReactNode } from 'react';
import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';

interface StatsigWrapperProps {
  children: ReactNode;
  userID?: string;
}

export const StatsigWrapper: React.FC<StatsigWrapperProps> = ({ children, userID }) => {
  const statsigClientKey = process.env.REACT_APP_STATSIG_CLIENT_KEY || '';

  const { client } = useClientAsyncInit(
    statsigClientKey,
    { userID: userID || 'anonymous' },
    {
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin()
      ],
      environment: {
        tier: process.env.REACT_APP_ENVIRONMENT || 'development',
      },
    },
  );

  // If no Statsig key is provided, render children without Statsig
  if (!statsigClientKey) {
    console.warn('REACT_APP_STATSIG_CLIENT_KEY not found. Statsig features will be disabled.');
    return <>{children}</>;
  }

  return (
    <StatsigProvider client={client} loadingComponent={<div>Loading...</div>}>
      {children}
    </StatsigProvider>
  );
};
